// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Header-module--navigation--1II0G","logo":"Header-module--logo--3yAKW"};